import { render, staticRenderFns } from "./Certifikati.vue?vue&type=template&id=015d1737&"
import script from "./Certifikati.vue?vue&type=script&lang=js&"
export * from "./Certifikati.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports